import * as React from 'react';

import CompetitorComparison from 'components/CompetitorComparison';
import PricingCardsComponent from 'components/Website/Pricing';
import PricingGrid from 'components/Website/PricingCards/PricingGrid';
import { CommunityPlan } from 'components/CommunityPlan';
import { ArrowRightIcon } from '@heroicons/react/solid';
import Link from 'components/Link';
import GetInTouch from 'components/GetInTouch';

import {
  DASHBOARD_SIGNUP_MONTHLY,
  DASHBOARD_SIGNUP_QUARTERLY,
  DASHBOARD_SIGNUP_YEARLY,
  OPTION_FLOW_PAGE,
} from 'constants/pages';

import { CTAText, CTACard } from './styles';

const PRICING_TIER = [
  {
    name: 'Monthly',
    id: 'tier-monthly',
    href: DASHBOARD_SIGNUP_MONTHLY,
    price: 75,
    description: <div className="text-sm">Great Value. $75 Billed Monthly.</div>,
    discountphrase: 'Less than the profit of a single trade',
    discount: 24,
    mostPopular: false,
    border: 'from-blue-500 to-blue-500',
  },
  {
    name: 'Quarterly',
    id: 'tier-quarterly',
    href: DASHBOARD_SIGNUP_QUARTERLY,
    price: 65,
    description: (
      <div className="text-sm">
        16% Discount. <span className="line-through">$220</span> $195 Billed Quarterly.
      </div>
    ),
    discount: 60,
    discountphrase: 'Save $120/Year',
    mostPopular: false,
    border: 'from-blue-500 to-teal-500',
  },
  {
    name: 'Annual',
    id: 'tier-annual',
    href: DASHBOARD_SIGNUP_YEARLY,
    price: 55,
    description: (
      <div className="text-sm">
        25% Discount. <span className="line-through">$900</span> $660 Billed Yearly.
      </div>
    ),
    discountphrase: 'Save $240/Year',
    discount: 240,
    mostPopular: true,
    border: 'from-teal-500 to-teal-500',
  },
];

const ROW_NAMES = [
  'Real-Time Options Order Flow',
  'Dark Pool & Equity Prints',
  'Crypto & Forex Market Scanner + News',
  'Robust Technical Analysis',
  'Live Trade Ideas With Proven Track Record',
  'Unusual Options Activity + Sweep Activity',
  'Unmatched Market Context & Sentiment',
  'Actionable Charts To Visualize Flow',
  'Industry Leading Analysis For Every Ticker',
  'Proprietary Indicators & Signals',
  'One-Click Dashboard Filtering',
  'Real-Time News + Sentiment',
  'On-Demand Historical Data',
  'Custom Watchlist',
  'Discord Access',
];

const IS_DISCOUNT_TEXT_VISIBLE = false;
const PricingCards = () => {
  return (
    <div className="-mt-16">
      {IS_DISCOUNT_TEXT_VISIBLE && (
        <>
          <CTAText className="mb-2 block text-center text-lg font-bold">
            EXCLUSIVE FOUNDER'S PRICING FOR A LIMITED TIME
          </CTAText>
          <div className="px-4">
            <CTACard className="mx-auto mb-8 max-w-4xl" border>
              <div className="p-1 text-center text-lg font-medium leading-8">
                <div>
                  Try the most actionable real-time options dashboard available today and lock in
                  your <strong>LIFETIME founder’s price</strong> — Sign up before offer ends
                </div>
              </div>
            </CTACard>
          </div>
        </>
      )}
      <PricingCardsComponent pricingTiers={PRICING_TIER} />
      <div className="mx-auto max-w-7xl px-4">
        <div className="mb-12 flex flex-col items-center justify-between gap-4 rounded-2xl border-2 border-electric-teal bg-palette-black-4 p-10 lg:flex-row">
          <h2 className="text-xl">
            <span className="font-bold text-electric-teal">Not ready to subscribe?</span> Try before
            you buy with our free options flow.
          </h2>
          <Link
            href={OPTION_FLOW_PAGE}
            className="flex items-center justify-center rounded-md bg-electric-teal px-6 py-3 text-lg font-bold text-black visited:text-black"
          >
            Use Free Options Flow <ArrowRightIcon className="ml-2 w-[1.125rem]" />
          </Link>
        </div>
      </div>
      <GetInTouch />
      <PricingGrid rowItems={ROW_NAMES} />
      <CommunityPlan />
      <div className="mx-auto mt-16 max-w-7xl px-4">
        <CompetitorComparison />
      </div>
    </div>
  );
};

export default PricingCards;
